import { render, staticRenderFns } from "./payment-setting-komcard.vue?vue&type=template&id=0df6c6e9&"
import script from "./payment-setting-komcard.vue?vue&type=script&lang=js&"
export * from "./payment-setting-komcard.vue?vue&type=script&lang=js&"
import style0 from "./payment-setting-komcard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports